import { makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import { currencyFormatter } from "../../../../services";
import { COLORS } from "../../../../theme/colors";

import { GlanceData } from "./sample";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
  require: {
    color: COLORS.purple,
  },
  tabelFooter: {
    borderLeft: "1px solid rgba(0, 0, 0, 0.25)",
    borderRight: "1px solid rgba(0, 0, 0, 0.25)",
    display: "flex",
    justifyContent: "space-between",
  },
  GlanceTitle: {
    fontSize: "14px",
    lineHeight: "36px",
  },
  Glancevalue: {
    fontSize: "18px",
    color: COLORS.darks[0][100],
    fontWeight: "800",
    lineHeight: "36px",
  },
  GlanceSpan: {
    fontSize: "14px",
    lineHeight: "36px",
    fontWeight: "400",
  },
  itemContainer: {
    padding: `${theme.spacing(0)}px ${theme.spacing(3.5)}px`,
    display: "flex",
    justifyContent: "space-between",
    width: "400px",
  },
}));
const RevenuesGlance = () => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <div className={classes.tabelFooter}>
      {GlanceData?.map((item, index) => {
        return (
          <>
            <div
              style={
                GlanceData.length - 1 !== index
                  ? { borderRight: "1px solid rgba(0, 0, 0, 0.25)" }
                  : {}
              }
              className={classes.itemContainer}
            >
              <div>
                <Typography className={classes.GlanceTitle}>{item.title}</Typography>
                <Typography className={classes.Glancevalue}>
                  {item.value} <span className={classes.GlanceSpan}>tCO2</span>
                </Typography>
                <Typography className={classes.Glancevalue}>
                  {currencyFormatter(item.price, currencySymbol)}{" "}
                  <span className={classes.GlanceSpan}>Total Revenues </span>
                </Typography>
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default RevenuesGlance;
